/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import { asyncConnect } from 'redux-connect';

import SignIn from './components/SignIn';
import SignInWap from './components/SignInWap';
import SignUp from './components/SignUp';
import SignUpWap from './components/SignUpWap';
// import GRHeader from '../../../components/GRHeader';
import Warning from './../../../components/Warning';
import ApplyCSS from '../../../components/ApplyCSS';
import * as labelsActions from '../../../components/labels/actions';
import commonUtil from '../../../utils/commonUtil';
import { _handleUserRegistration, _handleUserLogin } from './actions';
import * as defaultConst from '../../../utils/clientConstant';
import AppEvents from '../../App/AppEvents';
import serverClientUtil from '../../../utils/serverClientUtil';
import Tagging from '../../../components/Tagging/Tagging';

const { isLablesLoaded, loadLables } = labelsActions;
const applicationRoutes = commonUtil.getApplicationRoutes();

const channel = commonUtil.getChannel().toUpperCase();

@asyncConnect([{
  deferred: false,
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  user: store.user,
}),
  { ...labelsActions })

class CreateAccount extends Component {

  constructor() {
    super();
    this.warningMessage = null;
    this.errorData = '';
    this.changeComponentOnBackButtonClick = this.changeComponentOnBackButtonClick.bind(this);
    this.wapBackButtonEvent = null;
  }

  componentWillReceiveProps(nextProps) {
    const user = nextProps.user.data;
    this.errorData = user;
    if (user && !nextProps.user.loading && user.result && user.result.status && user.result.status.status === 'success' && this.warning) {
      this.warning.setMessage('');
      if (user && user.result && user.result.redirectToChangePassword === 'Yes') {
        const _url = serverClientUtil.getLPFullURL() + '/users/changePassword';
        const _dataLayer = this.getTaggingData(user, _url);
        this.tagging.applyGTM('Login', _dataLayer);
        window.location.href = _url;
      }
    } else if (user && user.result && !nextProps.user.loading && user.result.status && user.result.status.status === 'failure') {
      this.warning.setMessage(user.result.status.errorMessage);
    } else if (user && user.result && user.result.status === 'failure' && user.result.errorCode === 500) {
      this.warning.setMessage(user.result.errorMessage);
    }
  }

  componentWillMount() {
    // redirect to the auth0 login page from eCommerce website
    if (!this.props.user.data.result || !this.props.user.data.result.firstName) {
      const url = serverClientUtil.getLPFullURL();
      const redirectUrl = 'https:' + url + '/login';
      const redirectBackUrl = window.location.origin;
      window.location.replace(`${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`);
    }
  }

  componentDidMount() {
    this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [this.changeComponentOnBackButtonClick]);
    }

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: window.location.pathname,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Crear cuenta',
      Site: 'Mesa de Regalos',
    });
  }
  componentWillUnmount() {
    AppEvents.unsubscribe(this.wapBackButtonEvent);
  }
  changeComponentOnBackButtonClick = () => {
    browserHistory.push('/');
  }

  getTaggingData = (data, URL) => {
    const _dataLayer = {};
    const _loginInfo = {};

    _dataLayer.event = 'Login';
    _dataLayer.category = 'Login';
    _loginInfo.url = URL;
    _dataLayer.login = commonUtil.getUserInfo(data);

    return _dataLayer;
  }
  showMobileCreateAccountSection = () => {
    const sectionSesion = document.querySelector('#sectionSesion');
    const sectionAccount = document.querySelector('#sectionAccount');
    sectionSesion.style.display = 'none';
    sectionAccount.style.display = 'block';
  }

  isError = false;
  errorMessage = '';

  render() {
    const { lables, user } = this.props;
    const selectedEventConfiguration = (this.props.location && this.props.location.state && this.props.location.state.selectedEventConfiguration) ? this.props.location.state.selectedEventConfiguration : null;
    if (user && user.data && user.data.actionType && user.data.result && user.data.result.status && user.data.result.status.status === defaultConst.constAPISuccess) {
      // all condition for WAP channel
      if (channel === 'WAP' && this.props.location && this.props.location.query && this.props.location.query.redirecturl) {
        const _url = this.props.location.query.redirecturl;
        const _dataLayer = this.getTaggingData(user.data, _url);
        this.tagging.applyGTM('Login', _dataLayer);

        browserHistory.push(_url); // for session expire redirect to same page
        return null;
      }
      if (channel === 'WAP' && selectedEventConfiguration && user.data.result.myEventDetail && user.data.result.myEventDetail.length > 0) {
        const _dataLayer = this.getTaggingData(user.data, applicationRoutes.selectWhichMesa);
        this.tagging.applyGTM('Login', _dataLayer); // for anonymous user have events redirects selectWhich Mesa

        browserHistory.push({ pathname: applicationRoutes.selectWhichMesa, state: selectedEventConfiguration });
        return null;
      }
      if (browserHistory && channel === 'WAP') {
        if (channel === 'WAP' && selectedEventConfiguration) {
          const _dataLayer = this.getTaggingData(user.data, selectedEventConfiguration.url);
          this.tagging.applyGTM('Login', _dataLayer); // for anonymous user createAccount redirect 1st step

          browserHistory.push({ pathname: selectedEventConfiguration.url, state: selectedEventConfiguration });
        } else if (this.props.location.state && this.props.location.state.redirectTo) {
          const _redirectTo = this.props.location.state.redirectTo; // for anonymous user with no events redirect 1st step

          const _dataLayer = this.getTaggingData(user.data, _redirectTo);
          this.tagging.applyGTM('Login', _dataLayer);

          browserHistory.push(_redirectTo);
        } else {
          const _dataLayer = this.getTaggingData(user.data, applicationRoutes.home);
          this.tagging.applyGTM('Login', _dataLayer);
          browserHistory.push(applicationRoutes.home); // for anonymous user with no events redirect to home
        }
      }
      if (channel === 'WAP' && user.data.result.myEventDetail && user.data.result.myEventDetail.length === 1) {
        const _url = commonUtil.routeTo(applicationRoutes.giftList, { eventID: user.data.result.myEventDetail[0].eventId });
        const _dataLayer = this.getTaggingData(user.data, _url);
        this.tagging.applyGTM('Login', _dataLayer); // redirect to eventadmin when one events
      }
      if (channel === 'WAP' && user.data.result.myEventDetail && user.data.result.myEventDetail.length > 1) {
        const _url = commonUtil.routeTo(applicationRoutes.multipleEvents);
        const _dataLayer = this.getTaggingData(user.data, _url); // redirect to multiple when more than one events
        this.tagging.applyGTM('Login', _dataLayer);
      }
      //  all condition for WEB channel
      if (channel === 'WEB' && this.props.location && this.props.location.query && this.props.location.query.redirecturl) {
        const _url = this.props.location.query.redirecturl;
        const _dataLayer = this.getTaggingData(user.data, _url); // for session expire redirect to same page
        this.tagging.applyGTM('Login', _dataLayer);

        browserHistory.push(_url);
        return null;
      } else if (channel === 'WEB' && user.data.result.myEventDetail && user.data.result.myEventDetail.length > 0) {
        const _dataLayer = this.getTaggingData(user.data, applicationRoutes.selectWhichMesa);
        this.tagging.applyGTM('Login', _dataLayer); // for anonymous user have events redirects selectWhich Mesa

        browserHistory.push({ pathname: applicationRoutes.selectWhichMesa, state: selectedEventConfiguration });
        return null;
      }
      if (browserHistory && channel === 'WEB') {
        if (channel === 'WEB' && selectedEventConfiguration) {
          const _dataLayer = this.getTaggingData(user.data, selectedEventConfiguration.url);
          this.tagging.applyGTM('Login', _dataLayer); // for anonymous user createAccount redirect 1st step

          browserHistory.push({ pathname: selectedEventConfiguration.url, state: selectedEventConfiguration });
        } else if (this.props.location.state && this.props.location.state.redirectTo) {
          const _redirectTo = this.props.location.state.redirectTo; // for anonymous user with no events redirect 1st step

          const _dataLayer = this.getTaggingData(user.data, _redirectTo);
          this.tagging.applyGTM('Login', _dataLayer);

          browserHistory.push(_redirectTo);
        } else {
          const _dataLayer = this.getTaggingData(user.data, applicationRoutes.home);
          this.tagging.applyGTM('Login', _dataLayer);
          browserHistory.push(applicationRoutes.home); // for anonymous user with no events redirect to home
        }
      }
    }
    return (
      <React.Fragment>
        {/* <GRHeader {...this.props} /> */}
        <ApplyCSS pageName="createAccount" />
        <Tagging ref={tagging => this.tagging = tagging} />
        <div id="giftRegistry">
          <div className="row innerWrap createEventAnimationRight">
            {channel === 'WAP' ?
              <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
              :
              null}
            {channel === 'WEB' && (
              <div className="col-md-12">
                <div className="col-xs-12 col-md-11 col-md-offset-1" id="sectionHeadText">
                  <h2 style={{ textAlign: 'center', fontWeight: 'bold' }} className="textAlignCenter fontBold">{commonUtil.getLabel(lables.createLogin, 'createLogin.register.account')}</h2>
                  <p>{commonUtil.getLabel(lables.createLogin, 'createAccount.register.account.message')}</p>
                </div>
                <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
                <div className="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 text-right" id="sectionAlert">
                  <p className="alertRequired">{commonUtil.getLabel(lables.createLogin, 'createLogin.mandatory.fields.message')}</p>
                </div>
              </div>)
            }
            <div className={channel === 'WAP' ? '' : 'col-sm-12 col-md-12'}>
              {channel === 'WAP' ? <SignInWap _handleUserLogin={this.props._handleUserLogin} lables={this.props.lables} showMobileCreateAccountSection={this.showMobileCreateAccountSection} ref={_logoutLi => this._logoutLi = _logoutLi} errorData={this.errorData} /> : <SignIn lables={this.props.lables} _handleUserLogin={this.props._handleUserLogin} />}
              {channel === 'WAP' ? <SignUpWap _handleUserRegistration={this.props._handleUserRegistration} lables={this.props.lables} ref={_logoutLi => this._logoutLi = _logoutLi} errorData={this.errorData} /> : <SignUp lables={this.props.lables} _handleUserRegistration={this.props._handleUserRegistration} />}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
});
const matchDispatchToProps = dispatch => bindActionCreators({ _handleUserLogin, _handleUserRegistration }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(CreateAccount);
